import { Module } from "vuex";

import { DeskState } from "./types";

import { actionNames, actions } from "./actions";
import { RootState } from "../../types";
import { mutationNames, mutations } from "./mutations";
import { getterNames, getters } from "./getters";

export const api = {
  namespace: "desk",
  getters: getterNames,
  mutations: mutationNames,
  actions: actionNames,
  state: {
    user: "desk",
  },
};

const module: Module<DeskState, RootState> = {
  namespaced: true,
  state: () => new DeskState(),
  actions,
  mutations,
  getters,
};

export default module;
